export const AwsUrl =
  "https://easyrent.s3.eu-central-1.amazonaws.com/Properties/";
export const AwsUrlBlog =
  "https://easyrent.s3.eu-central-1.amazonaws.com/BlogPost/";
